import { render, staticRenderFns } from "./xczpzj.vue?vue&type=template&id=445a00aa&scoped=true&"
import script from "./xczpzj.vue?vue&type=script&lang=js&"
export * from "./xczpzj.vue?vue&type=script&lang=js&"
import style0 from "./xczpzj.vue?vue&type=style&index=0&id=445a00aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a00aa",
  null
  
)

export default component.exports